import FirstTimeUserInstructionModal from '@Components/Shared/Modals/FirstTimeUserInstructionModal';
import { useTheme } from '@mui/material/styles';
import { useState } from 'react';
import { ThemedLinkButton } from '@Components/MuiWrappers/Button';
import translator from '@Components/Utilities/Translator';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';

const FirstTimeUserInstructionBanner = (props) => {

    const theme = useTheme();
    const currentSite = useRecoilValue(atoms.currentWebsite);

    const [showModal, setShowModal] = useState(false);

    const onModalClose = () => {
        setShowModal(false);
    };

    return (
        <>
            {showModal && <FirstTimeUserInstructionModal {...props} onClose={onModalClose} isDarkMode={theme.palette.mode == 'dark'} />}
            <div class="first-time-user-instruction-banner">
                <h2>{translator.translate('sandhills.welcometothenew', [currentSite.ProperDisplayDomainName])}</h2>
                <ThemedLinkButton id='first-time-user-video' variant='text' size='small' onClick={() => setShowModal(true)}
                    sx={{ margin: '0 0 10px 0', textDecoration: 'underline', color: theme.palette.mode == 'dark' ? 'black' : 'white' }}>
                    {translator.translate('sandhills.watchourinstructionalvideotolearnmore')}
                </ThemedLinkButton>
            </div>
        </>
    );
};

export default FirstTimeUserInstructionBanner;
